import classNames from "classnames";
import React, { KeyboardEventHandler } from "react";

import CreatableSelect from "react-select/creatable";
import { components } from "react-select";
import { getDropdownStylesControl, dropdownStylesOption } from "./CiroDropdown";
import CiroErrorMsg from "./forms/CiroErrorMsg";

interface ICiroCreateableTextInput {
  containerWidthClass?: string;
  label?: string | React.ReactNode;
  placeholder?: string;
  value: string[];
  setValue: (value: string[]) => void;
  error?: string;
  maxDisplayedOptions?: number;
}

const CiroCreateableTextInput = ({
  containerWidthClass,
  label,
  placeholder,
  value,
  setValue,
  error,
  maxDisplayedOptions,
}: ICiroCreateableTextInput) => {
  const createOption = (label: string) => ({
    label,
    value: label,
  });

  const [inputValue, setInputValue] = React.useState("");

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        const newValue = [...value, inputValue];
        setValue(newValue);
        setInputValue("");
        event.preventDefault();
    }
  };

  const MultiValueContainer = (props: any) => {
    const { data, selectProps } = props;
    const { value } = selectProps;
    const maxOptions = maxDisplayedOptions || Infinity;
    
    // If this value is not among the first maxOptions, don't render it
    if (maxDisplayedOptions && Array.isArray(value)) {
      const valueIndex = value.findIndex((val: any) => 
        val.value === data.value
      );
      
      if (valueIndex >= maxOptions) {
        return null;
      }
      
      // If this is the last visible option and there are more hidden options
      if (valueIndex === maxOptions - 1 && value.length > maxOptions) {
        return (
          <components.MultiValueContainer {...props}>
            {props.children}
            <span className={classNames("pl-2", "text-sm", "text-gray-500", "bg-white", "pt-1")}>
              +{value.length - maxOptions} more
            </span>
          </components.MultiValueContainer>
        );
      }
    }
    
    return <components.MultiValueContainer {...props} />;
  };

  const customComponents = {
    DropdownIndicator: null,
    ...(maxDisplayedOptions ? { MultiValueContainer } : {}),
  };

  return (
    <div className={classNames("flex", "flex-col", "items-start", "w-full")}>
      {label && <div className={classNames("pb-2")}>{label}</div>}
      <CreatableSelect
        classNames={{
          container: () => (containerWidthClass ? containerWidthClass : ""),
        }}
        components={customComponents}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={(newValue) => {
          setValue(newValue.map((v) => v.value));
        }}
        onInputChange={(newValue) => setInputValue(newValue)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        styles={{
          control: getDropdownStylesControl({}),
          option: dropdownStylesOption,
        }}
        value={value.map((v) => createOption(v))}
      />
      {error && <CiroErrorMsg error={error} />}
    </div>
  );
};

export default CiroCreateableTextInput;
